import { DonationStore } from "../shared/store";
import { MembershipStore } from "./membership";
import { ProductStore } from "./products";
import { ServiceStore } from "./services";

 

class Root {
    public productStore: ProductStore;
    public serviceStore: ServiceStore;
    public membershipStore: MembershipStore;
    public donationStore: DonationStore;
    constructor() {
        this.productStore = new ProductStore();
        this.serviceStore = new ServiceStore();
        this.membershipStore = new MembershipStore();
        this.donationStore = new DonationStore();
    }
}

const RootStore = new Root();
export default RootStore;
